export default "__VITE_ASSET__DXUjo8EZ__"